interface SelectedRowsCounterProps {
  selectedRows: any[];
  selectedVirtualRows: number;
  className?: string;
}

const SelectedRowsCounter = ({
  selectedRows,
  selectedVirtualRows,
  className,
}: SelectedRowsCounterProps) => {
  const totalSelectedRows = selectedRows.length + selectedVirtualRows;

  if (totalSelectedRows === 0) {
    return null;
  }

  return <span className={className}>{` (${totalSelectedRows})`}</span>;
};

export default SelectedRowsCounter;
